<template>
    <div
        class="pet-dropdown-section"
        :style="{ 'background-color': bg_color || 'white' }"
    >
        <div :class="{'pet-dropdown-static':true,
        'height-auto':second_name}" @click="toggleCollapsed()">
            <div class="pet-dropdown-side-section">
                <div class="image-wrapper">
                    <img
                        v-if="address_privacy"
                        class="image_lock"
                        :src="lock_profile"
                    />
                    <img v-else-if="img_src && !img_src.includes('default.png')" :class="{'image':!isSvg,'image-svg':isSvg}" :src="img_src" />
                    <img v-else :src="default_profile" :class="{'image-default':colored_text.text.includes('PRIMARY'),'image-default-gray':!colored_text.text.includes('PRIMARY')}" />
                </div>
                <div class="dropdown-left-text" v-if="!address_privacy">
                    <h2 >{{ name }}</h2>
                    <h2 v-if="second_name">{{ second_name }}</h2>
                    <p
                        v-if="colored_text && colored_text.text"
                        class="colored-small"
                        :style="{ color: colored_text.color }"
                    >
                        {{ colored_text.text }}
                    </p>

                    <p v-else>{{ gray_text }}</p>
                </div>
                <div class="dropdown-left-text" v-else>
                <h2>Hidden</h2>
                <p>Hidden</p>
                </div>
            </div>

            <div v-if="!hideExpand" class="pet-dropdown-arrow">
                <img :src="collapse ? down_arrow : up_arrow" />
            </div>
        </div>
        <XyzTransition v-if="!hideExpand" xyz="fade up">
            <div v-if="!collapse">
                <div v-if="!bg_color" class="devider" />
                <div class="collapsed_section">
                    <slot />
                </div>
            </div>
        </XyzTransition>
    </div>
</template>

<script>
export default {
    name: "PetButtonDropDown",
    props: [
        "img_src",
        "bg_color",
        "name",
        "second_name",
        "gray_text",
        "colored_text",
        "expanded",
        "address_privacy",
        "hideExpand"
    ],
    data() {
        return {
            isSvg:false,
            collapse: true,
            lock_profile: require("@/assets/svg/login/lock.svg"),
            default_profile: require("@/assets/svg/pet-card-icon/null_photo.svg"),
            down_arrow: require("@/assets/svg/pet-card-tabs/down-arrow.svg"),
            up_arrow: require("@/assets/svg/pet-card-tabs/up-arrow.svg"),
        };
    },
    mounted(){
            this.$nextTick(()=>{
                if(this.img_src && this.img_src.includes('.svg')){
                    this.isSvg = true;
                }
                if(this.expanded === true){
                        this.collapse = false;
                }
            })
    },
    methods: {
        toggleCollapsed() {
            this.collapse = !this.collapse;
        },
    },
};
</script>

<style scoped>
.pet-dropdown-collapse {
    display: none;
}
.collapsed_section {
    padding: 1rem;
    background: rgba(253,253,235,0.2);
}
.devider {
    width: 100%;
    height: 1px;
    background: #f4f5f6;
    mix-blend-mode: normal;
}
.colored-small {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
}

.image_lock {
    height: 46px;
    width: 46px;
}
.pet-dropdown-section {
    box-sizing: border-box;
    width: 86.4%;
    box-shadow: 0px 13px 40px rgba(27, 25, 86, 0.06);
    border-radius: 16px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    height: auto;
    transition: 1s ease-in;
}
.height-auto{
    height: auto !important;
}
.pet-dropdown-static {
    display: flex;
    height: 82px;
    padding: 0.9rem;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: pointer;
}
.pet-dropdown-side-section {
    display: flex;
    justify-content: left;
    height: 100%;
    width: 100%;
    align-items: center;
}
.pet-dropdown-arrow {
    right: 1rem;
    position: absolute;
}
.pet-dropdown-side-section .image {
    width: 48px;
    height: 48px;
    border-radius: 15px;
    background-size: cover;
}

.pet-dropdown-side-section .image-svg {
    width: 48px;
    height: 48px;
    box-sizing: border-box;
    border-radius: 15px;
    background-size: cover;
}

.pet-dropdown-side-section .image-default {
    width: 48px;
    height: 48px;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 15px;
    background-size: cover;
    background: rgb(98, 102, 240);
}

.pet-dropdown-side-section .image-default-gray {
    width: 48px;
    height: 48px;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 15px;
    background-size: cover;
    background: #CECECE;
}
.dropdown-left-text {
    align-items: center;
    padding-left: 1rem;
    width: calc(100% - 14px - 48px - 1rem);
}
.hw-big{
    height: 54px !important;
    width: 54px !important;
}
.dropdown-left-text p {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #75818f;
    width: calc(100% - 14px);
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.dropdown-left-text h2 {
    font-size: 1rem;
    line-height: 24px;
    color: #00133d;
}
</style>
